import { render, staticRenderFns } from "./Episodes.vue?vue&type=template&id=11822d28&scoped=true&"
import script from "./Episodes.vue?vue&type=script&lang=js&"
export * from "./Episodes.vue?vue&type=script&lang=js&"
import style0 from "./Episodes.vue?vue&type=style&index=0&id=11822d28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11822d28",
  null
  
)

export default component.exports